export default "__VITE_ASSET__C72yuHdd__"